export default __webpack_public_path__ + "static/media/check-circle.6bd267c2.svg";